<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Effective Interactive Session between the students of Frobel Academy and
      Proyash-Chattogram
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        There was an effective interactive session between the students of
        Frobel Academy and Proyash-Chattogram. We believe in "Sharing is
        caring". Thanks Frobel Academy for such a humanitarian effort towards an
        inclusive society... Together with such a humane venture, our
        development is inclusive and sustainable. <br />
        <br />
        ফ্রবেল একাডেমী এবং প্রয়াস-চট্টগ্রামের শিক্ষার্থীদের মধ্যে একটি কার্যকর
        ইন্টারেক্টিভ সেশন ছিল। আমরা বিশ্বাস করি "Sharing is caring". একটি
        অন্তর্ভুক্তিমূলক সমাজের প্রতি এমন মানবিক প্রচেষ্টার জন্য Frobel
        একাডেমিকে ধন্যবাদ... এই ধরনের একটি মানবিক উদ্যোগ আমাদের উন্নয়নকে
        অন্তর্ভুক্তিমূলক এবং টেকসই করবে।
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
